/**
 * Firebase initialization – Auth and Firestore.
 * Validates env before init; does not throw to allow build without .env.
 */

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getValidatedEnv } from '@/config/env'

let auth: ReturnType<typeof getAuth>
let db: ReturnType<typeof getFirestore>

function initFirebase() {
  const env = getValidatedEnv()
  const config = {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  }
  const app = initializeApp(config)
  auth = getAuth(app)
  db = getFirestore(app)
}

initFirebase()

export { auth, db }
